import React from 'react'

const SectionTitle = ({ value, className }) => {
    return (
        <h1 className={`text-6xl mb-4 ${className}`}>{value}</h1>
    )
}

export default SectionTitle